import HtmlElementHelper from '../../../Shared/Helpers/htmlElementHelper';
import NumberHelper from '../../../Shared/Helpers/numberHelper';

var id = "";

jQuery(document).click(function (e)
{
    var isNotCurrencyCtrl = !jQuery(e.target).hasClass("arrowImg") && !jQuery(e.target).hasClass("search_input_dropdown") &&
                            !jQuery(e.target).hasClass("dropdown") && !jQuery(e.target).hasClass("displayCurrency") &&
                            !jQuery(e.target).hasClass("displayFlag");

    if (isNotCurrencyCtrl)
        hideDropdownContent();
});

jQuery( document ).on( 'keydown', function (e) {
    if (e.keyCode === 27 ) { // ESC
        hideDropdownContent();
    }
});

function hideDropdownContent() {
    jQuery(".dropdown-content").hide();
}

var iOs = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
var documentClick = true;

if (iOs)
{  

    jQuery(".dropdown-tr").on('touchstart', function() {
        documentClick = true;
    });
    jQuery(".dropdown-tr").on('touchmove', function() {
        documentClick = false;
    });
}

jQuery(".dropdown-tr").unbind('click');
jQuery(".dropdown-tr").on('click', function(event) {
        if (event.type == "click") documentClick = true;
        if (documentClick){
            changeCurrency(this);
        }
    });

function changeCurrency(element) {
    
    //default Sku for Cuba. If choose another country, it is not clear what product was selected initially
    var defaultSku = jQuery("#default_sku").val();

    var changedCurrency = jQuery(element).find(".td-currency")[0].innerHTML;
    var changedCountry = jQuery(element).find(".td-country")[0];

    var country = jQuery(changedCountry).data("t");
    jQuery(".receiverAmount .dropdown").data("country", country);
    
    var product = jQuery(element).data("product");
    
    if(product)
        jQuery("#receiverCurrency").data('product', product);
    
    changeHiddenInputCurrency(id, changedCurrency);
    changeDisplayElement(element);

    var senderCurrency = jQuery("#senderCurrency").val();
    var isReceiverDd = jQuery(element).parents("#dropdown_receiverCurrency").length > 0;
    if(isReceiverDd && senderCurrency == changedCurrency){
        var currencies = jQuery("#dropdown_senderCurrency .td-currency").filter(function(i, item){
            return item.textContent != changedCurrency;
        });

        senderCurrency = currencies[0].textContent;
    }
        
    var receiverCurrency = jQuery("#receiverCurrency").val();
    var currencyType = id;
    var senderAmount = jQuery("#senderAmount").val();


    /* In banking, product is always the product of the receiving country */
    if(!product) {
        product = jQuery("#receiverCurrency").data('product');
    }

    jQuery('#productSku').val(product);
    console.log("Set product sku to ", jQuery('#productSku').val());

    /* g_unBlockUI() is in getMulticurrencyAjax() method */
    HtmlElementHelper.g_blockUI();

    getMulticurrencyAjax(senderCurrency, receiverCurrency, product, currencyType, senderAmount);
    
    if(product.indexOf("cuba") !== -1)
        changeCubaBtnStyle(receiverCurrency);
}

function changeCubaBtnStyle(receiverCurrency) {
    if (receiverCurrency === "USD" || receiverCurrency === "MLC") {
        jQuery(".cuba-cuc-btn").removeClass("disabled");
        jQuery(".cuba-usd-btn").addClass("disabled");
    } else if (receiverCurrency === "CUP") {
        jQuery(".cuba-usd-btn").removeClass("disabled");
        jQuery(".cuba-cuc-btn").addClass("disabled");
    }
}

window.changeMulticurrencyForCubaBtn = function (receiverCurrency) {
    var receiverAmount = jQuery("#receiverAmount").val();
    var senderCurrency = jQuery("#senderCurrency").val();

    var digits = NumberHelper.getFixedDigits(senderCurrency);

    var exchangeRateString = "1 " + senderCurrency + " = " + parseFloat(exchangeRate).toFixed(digits) + " " + receiverCurrency;
    changeCubaBtnStyle(receiverCurrency);

    jQuery("#receiverCurrency").val(receiverCurrency);
    jQuery("#amount-receivable").text(receiverAmount + " " + receiverCurrency);
    jQuery("#exchange-rate").text(exchangeRateString);
    jQuery("#dropdown-currency-label-receiverCurrency").find(".displayCurrency").text(receiverCurrency);
}

function getMulticurrencyAjax(senderCurrency, receiverCurrency, product, currencyType, senderAmount) {

    var changeMulticurrencyArrayURL = window.banking.multiCurrencyChangeAjaxUrl;

    jQuery.ajax(changeMulticurrencyArrayURL, {
        method: "POST",
        data: {"senderCurrency": senderCurrency, "receiverCurrency": receiverCurrency, "product": product,  "currencyType": currencyType, "senderAmount": senderAmount}
    }).always(function (data) {

        if(data && data.country) {
            var responseText = data; 
            var currencies = responseText["multiCurrencies"];
            var exchangeRate = responseText["exchangeRate"];
            var defaultCurrency = responseText["defaultCurrency"];
            var country = responseText["country"];
            var countryCode = responseText["countryCode"];
            var transferHeader = responseText["transferHeader"];
            var isTransferSummaryToUpdate = document.getElementById("updateTransferSummaryHeader") != null &&
                document.getElementById("transferSummaryHeader") != null;

            var fee = responseText["fee"];

            var dropdownToChange = null;

            switch (currencyType) {
                case ("receiverCurrency"):
                    dropdownToChange = "senderCurrency";

                    if (countryCode == "CU")
                        jQuery(".cuc-currencies-btn").show();
                    else
                        jQuery(".cuc-currencies-btn").hide();
                    break;
                case ("senderCurrency"):
                    dropdownToChange = "receiverCurrency";
                    break;
            }

            updateDropdownContent(currencies, dropdownToChange);

            if(!defaultCurrency && jQuery("#senderCurrency").val() == receiverCurrency){
                defaultCurrency = currencies[0];
            }

            if (defaultCurrency && defaultCurrency["currency"]) {
                var dropdown = jQuery("#dropdown-currency-label-" + dropdownToChange).parent();
                changeDropdownLabelElement(dropdown, defaultCurrency["currency"], defaultCurrency["flag"]);
                changeHiddenInputCurrency(dropdownToChange, defaultCurrency["currency"]);
            }

            var isExhangeRateUpdated = true;

            // senderCurrency = jQuery("#senderCurrency").val();
            // receiverCurrency = jQuery("#receiverCurrency").val();

            jQuery("#provider-fee").html("0.00 "+senderCurrency);

            if (country && transferHeader && isTransferSummaryToUpdate)
                updateCountryInTransferSummaryHeader(transferHeader);

            if (countryCode) {
                if(jQuery("input[name=country]"))
                    jQuery("input[name=country]").val(countryCode);
            }

            if (responseText["minTransferLimit"]) {
                var minTransferAmount = responseText["minTransferLimit"];
                window.banking.minTransferAmount = minTransferAmount;
                var validationAdviceMin = jQuery(".span-advice-too-little-money");
                validationAdviceMin.text(minTransferAmount+" "+senderCurrency);
            }

            if (responseText["maxTransferLimit"]) {
                var countryLimit = responseText["maxTransferLimit"];
                window.banking.countryLimit = countryLimit;

                var validationAdviceMax = jQuery(".span-advice-country-limit-exceeded");
                validationAdviceMax.text(countryLimit+" "+senderCurrency);
            }

            window.updateExchangeRate(exchangeRate, fee, senderCurrency, receiverCurrency, isExhangeRateUpdated);
        }
        HtmlElementHelper.g_unBlockUI();
        hideDropdownContent();
    });
}

function updateDropdownContent(currencies, dropdownId) {
    var dropdownContent = document.getElementById("dropdown_"+dropdownId);
    var dropdownTable = dropdownContent.getElementsByClassName("dropdown-table")[0];
    var dropdownTableBody = dropdownTable.getElementsByTagName("tbody")[0];
    dropdownTableBody.innerHTML = "";

    for (var i = 0; i<Object.keys(currencies).length; i++) {
        var currency = currencies[i];

        var currencyVal = currency["currency"];
        var country = currency["country"];
        var flag = currency["flag"];
        var product = currency["product"];

        var tr = generateRow(currencyVal, country, flag, product);
        dropdownTableBody.appendChild(tr);
    }

    jQuery("#dropdown-currency-label-"+dropdownId).prop("onclick", null).off("click");
    if (currencies.length > 1) {
        jQuery("#arrowImg-"+dropdownId).show();
        jQuery("#dropdown-currency-label-"+dropdownId).click(
            function(){
                toggleDropdown(dropdownId);
            });
    } else {
        jQuery("#arrowImg-"+dropdownId).hide();
    }
}

function generateRow(currency, country, flag, product) {
    var tr = document.createElement("tr");
    tr.setAttribute("class", "dropdown-tr");
    tr.dataset.product = product;
    tr.addEventListener('click', function(){
        changeCurrency(this);
    });

    var td_flag = document.createElement("td");

    var img = document.createElement("img");
    img.setAttribute("class", "td-flag");
    img.src = flag;
    td_flag.appendChild(img);

    if (country) {
        var td_country = document.createElement("td");
        var div_country = document.createElement("div");
        div_country.setAttribute("class", "td-country");

        if (product) {
            div_country.setAttribute("data-product", product);
        }
        div_country.innerHTML = country;
        td_country.appendChild(div_country);
    }

    var td_currency = document.createElement("td");
    var div_currency = document.createElement("div");
    div_currency.setAttribute("class", "td-currency");
    div_currency.innerHTML = currency;
    td_currency.appendChild(div_currency);

    tr.appendChild(td_flag);
    if (country)
        tr.appendChild(td_country);
    tr.appendChild(td_currency);

    return tr;
}

function changeHiddenInputCurrency(displayId, changedCurrency) {
    jQuery("#"+displayId).val(changedCurrency);
}

function changeDisplayElement(element) {
    var trElement = jQuery(element);

    var td_currency = trElement.find(".td-currency")[0];
    var td_country =  trElement.find(".td-country")[0];
    var td_flag = trElement.find(".td-flag")[0];

    if (td_currency)
        var currency = td_currency.innerHTML;

    if (td_country)
        var country = td_country.innerHTML;

    if (td_flag)
        var flag = td_flag.getAttribute('src');

    var dropdown = trElement.closest(".dropdown");
    changeDropdownLabelElement(dropdown, currency, flag, country);
}

function changeDropdownLabelElement($element, $currency, $flag) {
    var displayFlag = $element.find(".displayFlag")[0];
    var displayCurrency = $element.find(".displayCurrency")[0];

    displayFlag.src = $flag;
    displayCurrency.innerHTML = $currency;
}

function clearFilterDropdown() {
    jQuery("#search_input_"+id).val("");
    jQuery("#dropdown_" + id).find(".dropdown-tr").show();
    document.getElementById("dropdown_" + id).getElementsByClassName("search-warning")[0].style.display = "none";
}

window.toggleDropdown = function (_id) {
    id = _id;

    var left = 0, width = 0, height = 0, right=0, top= 0;
    var dropdownEl = jQuery("#dropdown_"+id);
    var boundingRectDropdownCurrency = jQuery(".dropdown-currency")[0].getBoundingClientRect();
    var boundingRectInputField = jQuery(".moneyInputField")[0].getBoundingClientRect();
    var boundingRectReceiverAmount = jQuery(".receiverAmount")[0].getBoundingClientRect();

    height = boundingRectDropdownCurrency.height + 5;

    switch (id) {
        case "senderCurrency":
            right  = -15;
            break;
        case "receiverCurrency":
            top = boundingRectReceiverAmount.bottom - boundingRectInputField.top + 5;
            left = boundingRectDropdownCurrency.left- boundingRectInputField.left + 5;
            width = boundingRectInputField.width;
            break;
        default:
            right  = -15;
            break;
    }

    dropdownEl.css("position", 'absolute');

    if (width)
        dropdownEl.css("width", width +"px");

    if (left)
        dropdownEl.css("left", "-"+left+"px");

    if (right)
        dropdownEl.css("right", right+"px");

    if (height)
        dropdownEl.css("margin-top", height+"px");

    if (top)
        dropdownEl.css("top", "-"+top+"px");

    clearFilterDropdown();

    dropdownEl.show();
    dropdownEl.scrollTop(0);
}

window.filterDropdown = function () {
    var search_input, filter;
    search_input = document.getElementById("search_input_"+id);
    filter = search_input.value.toUpperCase();
    var div = document.getElementById("dropdown_"+id);
    var tr = div.getElementsByClassName("dropdown-tr");
    var isSearchFound = false;

    for (var i = 0; i < tr.length; i++) {
        var spanElements = tr[i].getElementsByTagName("div");
        if (spanElements.length == 2) {
            var country_filter_index = spanElements[0].innerHTML.toUpperCase().indexOf(filter);
            var currency_filter_index = spanElements[1].innerHTML.toUpperCase().indexOf(filter);
        }
        else {
            var currency_filter_index = spanElements[0].innerHTML.toUpperCase().indexOf(filter);
        }

        if (country_filter_index> -1 || currency_filter_index> -1) {
            tr[i].style.display = "";
            isSearchFound = true;
        }
        else {
            tr[i].style.display = "none";
        }
    }

    if (isSearchFound) {
        div.getElementsByClassName("search-warning")[0].style.display = "none";
    }
    else {
        div.getElementsByClassName("search-warning")[0].style.display = "inline-block";
    }
}